import React, {Component} from "react";
import {Button, message, Switch ,Input, Radio,Form,Icon,Select,Card,Modal} from 'antd';
import getSize from "../../../utils/getSize";
import NHFetch from "../../../utils/NHFetch";
import {hasAuth} from "../../../utils/NHCore";
import NHTable from '../../common/NHTable';
import {NHConfirm} from '../../common/NHModal';
import NHContainerFrame from '../../common/NHContainerFrame';
import NHFormItem from '../../common/NHFormItem';
import NHSelect from '../../common/NHSelect/index'
import NHInputPicker from '../../common/NHInputPicker';

const { TextArea } = Input;
const RadioGroup = Radio.Group;
class EditInitForm extends React.Component {
    constructor(props) {
        super(props);
        this.state = {

        };
    }

    render() {
        const { form } = this.props;
        const editData=this.props.editData?this.props.editData:{};

        return (
            <Form>
                <NHFormItem label="字段名称" id={'zdmc'} form={form} initialValue={editData.ZDMC} required={true}>
                    <Input placeholder={'请输入对接方式名称...'} />
                </NHFormItem>
                <NHFormItem label="字段标志" id={'zdbz'} form={form} initialValue={editData.ZDBZ} required={true}>
                    <Input placeholder={'请输入字段标志...'} />
                </NHFormItem>
                <NHFormItem label="表单控件参数" id={'bdkjcs'} form={form} initialValue={editData.BDKJCS} required={true}>
                    <NHInputPicker />
                </NHFormItem>
                <NHFormItem label="是否必填" id={'sfbt'} form={form} initialValue={editData.SFBT?editData.SFBT:"0"} required={true}>
                    <RadioGroup>
                        <Radio value={"0"}>不必填</Radio>
                        <Radio value={"1"}>必填</Radio>
                    </RadioGroup>
                </NHFormItem>
                <NHFormItem label="字段提示" id={'zdts'} form={form} initialValue={editData.ZDTS}>
                    <TextArea placeholder={'请输入字段提示...'} rows={3}/>
                </NHFormItem>
                <NHFormItem label="字段描述" id={'zdms'} form={form} initialValue={editData.ZDMS}>
                    <TextArea placeholder={'请输入字段描述...'} rows={3}/>
                </NHFormItem>
            </Form>
        );
    }
}

const ModeEditForm = Form.create()(EditInitForm);
export default ModeEditForm;


// WEBPACK FOOTER //
// ./components/zxjfgl/jffagl/ModeEditForm.js